import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { CartLine } from "@/components/CartDrawer";
import { fmtPrice } from "@/data/catalog";

export const OrderSummary = ({ cta, onCta, loading, testId = "summary" }) => {
  const { t, i18n } = useTranslation();
  const { subtotal, shipping, total, count } = useCart();
  return (
    <div data-testid={testId} className="self-start rounded-3xl bg-black p-8 text-white lg:sticky lg:top-32">
      <h3 className="font-display text-xl font-bold">{t("checkout.summary")}</h3>
      <dl className="mt-6 space-y-3 text-sm">
        <div className="flex justify-between"><dt className="text-white/60">{t("cart.subtotal")} ({count} {count === 1 ? t("cart.item") : t("cart.items")})</dt><dd data-testid="summary-subtotal">{fmtPrice(subtotal, i18n.language)}</dd></div>
        <div className="flex justify-between"><dt className="text-white/60">{t("cart.shipping")}</dt><dd data-testid="summary-shipping">{shipping === 0 ? t("cart.free") : fmtPrice(shipping, i18n.language)}</dd></div>
        <div className="flex justify-between border-t border-white/15 pt-4 font-display text-xl font-bold"><dt>{t("cart.total")}</dt><dd data-testid="summary-total">{fmtPrice(total, i18n.language)}</dd></div>
      </dl>
      {cta && <button data-testid="summary-cta" onClick={onCta} disabled={loading} className="nv-btn-lime mt-8 w-full !py-4">{cta} <ArrowRight size={16} /></button>}
    </div>
  );
};

export default function Cart() {
  const { t } = useTranslation();
  const { items } = useCart();
  return (
    <main className="nv-container py-12">
      <h1 className="font-display text-4xl font-bold sm:text-5xl">{t("cart.title")}</h1>
      {items.length === 0 ? (
        <div data-testid="cart-page-empty" className="mt-12 rounded-3xl bg-[#f4f5f0] p-20 text-center">
          <ShoppingBag size={40} className="mx-auto text-black/30" />
          <p className="mt-4 font-display text-2xl font-bold">{t("cart.empty")}</p>
          <p className="mt-2 text-black/60">{t("cart.emptySub")}</p>
          <Link to="/eshop" className="nv-btn-dark mt-8">{t("cart.continue")}</Link>
        </div>
      ) : (
        <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_400px]">
          <div className="divide-y divide-black/10">{items.map((i) => <CartLine key={i.code} i={i} />)}</div>
          <div>
            <OrderSummary />
            <Link to="/checkout" data-testid="cart-checkout" className="nv-btn-lime mt-4 w-full !py-4">{t("cart.checkout")} <ArrowRight size={16} /></Link>
            <Link to="/eshop" className="mt-3 block text-center text-xs font-bold uppercase tracking-wider text-black/60 hover:text-black">{t("cart.continue")}</Link>
          </div>
        </div>
      )}
    </main>
  );
}
